import { formatDate } from './dateFormat';
/** Professional PDF of an Orderless Stock order (shared to the customer on WhatsApp). */
const COLS = [
  { key: 'no', label: '#', w: 8, align: 'left' },
  { key: 'design', label: 'Design', w: 56, align: 'left' },
  { key: 'batch', label: 'Batch/Shade', w: 26, align: 'left' },
  { key: 'pack', label: 'Pack', w: 20, align: 'left' },
  { key: 'size', label: 'Size', w: 22, align: 'left' },
  { key: 'qty', label: 'Qty', w: 16, align: 'right' },
  { key: 'wpb', label: 'Wt/Box', w: 18, align: 'right' },
  { key: 'tw', label: 'Total Wt', w: 20, align: 'right' },
];

const num = (n) => Number(n).toLocaleString('en-IN');
const r1 = (n) => Math.round(n * 10) / 10;
const clean = (v) => String(v === null || v === undefined || v === '' ? '-' : v).replace(/[^\x20-\x7E]/g, ' ');

export function orderPdfFileName(partyName) {
  const base = String(partyName || 'Order').replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'Order';
  return `Order_${base}_${new Date().toISOString().slice(0, 10)}.pdf`;
}

export async function buildOrderPdfDoc(partyName, lines, totals, note) {
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const M = 12;
  const W = 210 - M * 2;
  const pageBottom = 297 - 16;
  const dateStr = formatDate(new Date());
  let y = M;

  doc.setFillColor(30, 41, 59);
  doc.rect(M, y, W, 14, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('ORDER ENQUIRY - STOCK LIST', M + 4, y + 9.2);
  y += 20;

  doc.setTextColor(30, 41, 59);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('To:', M, y);
  doc.setFont('helvetica', 'normal');
  doc.text(clean(partyName), M + 9, y);
  doc.setFont('helvetica', 'bold');
  doc.text('Date:', M + W - 40, y);
  doc.setFont('helvetica', 'normal');
  doc.text(dateStr, M + W - 28, y);
  y += 6;
  if (note) {
    doc.setFont('helvetica', 'bold');
    doc.text('Note:', M, y);
    doc.setFont('helvetica', 'normal');
    const nl = doc.splitTextToSize(clean(note), W - 14);
    doc.text(nl, M + 12, y);
    y += nl.length * 4.6;
  }
  y += 3;

  const drawHead = () => {
    doc.setFillColor(226, 232, 240);
    doc.rect(M, y, W, 8, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(30, 41, 59);
    let x = M;
    COLS.forEach((c) => {
      if (c.align === 'right') doc.text(c.label, x + c.w - 2, y + 5.4, { align: 'right' });
      else doc.text(c.label, x + 2, y + 5.4);
      x += c.w;
    });
    y += 8;
  };
  drawHead();

  doc.setFontSize(9);
  lines.forEach((l, i) => {
    const wt = l.weight !== null && l.weight !== undefined ? l.weight : null;
    const cells = {
      no: String(i + 1),
      design: doc.splitTextToSize(clean(l.design_name), COLS[1].w - 4),
      batch: doc.splitTextToSize(clean(l.batch_shade), COLS[2].w - 4),
      pack: doc.splitTextToSize(clean(l.box_pack), COLS[3].w - 4),
      size: doc.splitTextToSize(clean(l.size_name), COLS[4].w - 4),
      qty: num(l.qty),
      wpb: wt !== null ? String(wt) : '-',
      tw: wt !== null ? num(r1(wt * Number(l.qty))) : '-',
    };
    const rows = Math.max(1, cells.design.length, cells.batch.length, cells.pack.length, cells.size.length);
    const h = rows * 4.4 + 3.2;
    if (y + h > pageBottom - 14) {
      doc.addPage();
      y = M;
      drawHead();
    }
    if (i % 2 === 1) {
      doc.setFillColor(248, 250, 252);
      doc.rect(M, y, W, h, 'F');
    }
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(30, 41, 59);
    let x = M;
    COLS.forEach((c) => {
      const v = cells[c.key];
      if (c.align === 'right') doc.text(String(v), x + c.w - 2, y + 4.6, { align: 'right' });
      else doc.text(v, x + 2, y + 4.6);
      x += c.w;
    });
    doc.setDrawColor(226, 232, 240);
    doc.line(M, y + h, M + W, y + h);
    y += h;
  });

  if (y + 22 > pageBottom) { doc.addPage(); y = M; }
  doc.setFillColor(226, 232, 240);
  doc.rect(M, y, W, 9, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text(`Grand Total:  ${totals.designs} designs`, M + 2, y + 6);
  doc.text(`${num(totals.qty)} boxes   |   ${num(totals.weight)} Kg`, M + W - 2, y + 6, { align: 'right' });
  y += 16;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text('Kindly confirm your order. Thank you!', M, y);

  const pages = doc.getNumberOfPages();
  for (let p = 1; p <= pages; p += 1) {
    doc.setPage(p);
    doc.setFontSize(8);
    doc.text(`Page ${p} of ${pages}`, 210 - M, 297 - 8, { align: 'right' });
  }
  return doc;
}

export async function buildOrderPdfFile(partyName, lines, totals, note) {
  const doc = await buildOrderPdfDoc(partyName, lines, totals, note);
  return new File([doc.output('blob')], orderPdfFileName(partyName), { type: 'application/pdf' });
}

/** Same order as ONE PNG image (for pasting straight into a WhatsApp chat). */
export async function buildOrderImageBlob(partyName, lines, totals, note) {
  const FONT = 'Arial, Helvetica, sans-serif';
  const W = 900;
  const PAD = 24;
  const cols = [
    { k: 'no', l: '#', w: 40, a: 'l' },
    { k: 'design', l: 'Design', w: 200, a: 'l' },
    { k: 'batch', l: 'Batch/Shade', w: 132, a: 'l' },
    { k: 'pack', l: 'Pack', w: 100, a: 'l' },
    { k: 'size', l: 'Size', w: 100, a: 'l' },
    { k: 'qty', l: 'Qty', w: 70, a: 'r' },
    { k: 'wpb', l: 'Wt/Box', w: 90, a: 'r' },
    { k: 'tw', l: 'Total Wt', w: 120, a: 'r' },
  ];
  const mctx = document.createElement('canvas').getContext('2d');
  mctx.font = `15px ${FONT}`;
  const wrap = (text, maxW) => {
    const out = [];
    let cur = '';
    String(text).split(' ').forEach((word) => {
      let w = word;
      while (mctx.measureText(w).width > maxW && w.length > 1) {
        let n = w.length - 1;
        while (n > 1 && mctx.measureText(w.slice(0, n)).width > maxW) n -= 1;
        if (cur) { out.push(cur); cur = ''; }
        out.push(w.slice(0, n));
        w = w.slice(n);
      }
      const t = cur ? `${cur} ${w}` : w;
      if (cur && mctx.measureText(t).width > maxW) { out.push(cur); cur = w; } else cur = t;
    });
    if (cur) out.push(cur);
    return out.length ? out : ['-'];
  };
  const LH = 20;
  const rows = lines.map((l, i) => {
    const wt = l.weight !== null && l.weight !== undefined ? l.weight : null;
    const cells = {
      no: [String(i + 1)],
      design: wrap(clean(l.design_name), cols[1].w - 16),
      batch: wrap(clean(l.batch_shade), cols[2].w - 16),
      pack: wrap(clean(l.box_pack), cols[3].w - 16),
      size: wrap(clean(l.size_name), cols[4].w - 16),
      qty: [num(l.qty)],
      wpb: [wt !== null ? String(wt) : '-'],
      tw: [wt !== null ? num(r1(wt * Number(l.qty))) : '-'],
    };
    const n = Math.max(...Object.values(cells).map((c) => c.length));
    return { cells, h: n * LH + 14 };
  });
  const noteLines = note ? wrap(`Note: ${clean(note)}`, W - PAD * 2) : [];
  const H = PAD + 52 + 12 + 26 + noteLines.length * LH + 14 + 36 + rows.reduce((s, r) => s + r.h, 0) + 52 + 40 + PAD;
  const scale = H * 2 <= 15000 ? 2 : 1;
  const canvas = document.createElement('canvas');
  canvas.width = W * scale;
  canvas.height = Math.ceil(H) * scale;
  const ctx = canvas.getContext('2d');
  ctx.scale(scale, scale);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, W, H);
  let y = PAD;
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(PAD, y, W - PAD * 2, 52);
  ctx.fillStyle = '#ffffff';
  ctx.font = `bold 22px ${FONT}`;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  ctx.fillText('ORDER ENQUIRY - STOCK LIST', PAD + 16, y + 26);
  y += 52 + 12;
  ctx.fillStyle = '#1e293b';
  ctx.font = `bold 16px ${FONT}`;
  ctx.fillText('To:', PAD, y + 13);
  ctx.font = `16px ${FONT}`;
  ctx.fillText(clean(partyName), PAD + 34, y + 13);
  ctx.textAlign = 'right';
  ctx.fillText(formatDate(new Date()), W - PAD, y + 13);
  ctx.textAlign = 'left';
  y += 26;
  ctx.font = `15px ${FONT}`;
  noteLines.forEach((t) => { ctx.fillText(t, PAD, y + 10); y += LH; });
  y += 14;
  const drawRow = (vals, yy, bold) => {
    ctx.font = `${bold ? 'bold ' : ''}15px ${FONT}`;
    let x = PAD;
    cols.forEach((c) => {
      const v = vals[c.k];
      v.forEach((t, li) => {
        ctx.textAlign = c.a === 'r' ? 'right' : 'left';
        ctx.fillText(t, c.a === 'r' ? x + c.w - 8 : x + 8, yy + 10 + 7 + li * LH);
      });
      x += c.w;
    });
    ctx.textAlign = 'left';
  };
  ctx.fillStyle = '#e2e8f0';
  ctx.fillRect(PAD, y, W - PAD * 2, 36);
  ctx.fillStyle = '#1e293b';
  const head = {};
  cols.forEach((c) => { head[c.k] = [c.l]; });
  drawRow(head, y + 2, true);
  y += 36;
  rows.forEach((r, i) => {
    if (i % 2 === 1) { ctx.fillStyle = '#f8fafc'; ctx.fillRect(PAD, y, W - PAD * 2, r.h); }
    ctx.fillStyle = '#1e293b';
    drawRow(r.cells, y, false);
    ctx.fillStyle = '#e2e8f0';
    ctx.fillRect(PAD, y + r.h - 1, W - PAD * 2, 1);
    y += r.h;
  });
  ctx.fillStyle = '#e2e8f0';
  ctx.fillRect(PAD, y + 8, W - PAD * 2, 40);
  ctx.fillStyle = '#1e293b';
  ctx.font = `bold 17px ${FONT}`;
  ctx.fillText(`Grand Total: ${totals.designs} designs`, PAD + 10, y + 8 + 21);
  ctx.textAlign = 'right';
  ctx.fillText(`${num(totals.qty)} boxes  |  ${num(totals.weight)} Kg`, W - PAD - 10, y + 8 + 21);
  ctx.textAlign = 'left';
  ctx.fillStyle = '#64748b';
  ctx.font = `15px ${FONT}`;
  ctx.fillText('Kindly confirm your order. Thank you!', PAD, y + 8 + 40 + 22);
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('image failed'))), 'image/png');
  });
}
